'use client'

import Link from "next/link"
import { Heart, User } from "lucide-react"
import { useModal } from "@/ui/context/ModalContext"
import { useAuth } from "@/ui/context/AuthContext"
import LoginModal from "@/ui/context/modals/Login"

export default function AccountButton() {
    const { openModal, closeModal } = useModal()
    const { user } = useAuth()
    
	return (
		<>
            { user ? (
                <div className="flex items-center gap-6">
                    <Link
                        href="/account/profile"
                        className="text-black font-semibold text-sm"
                    >
                        <span className="hidden lg:block">
                            Mon compte
                        </span>
                        <User className="size-5 lg:hidden" />
                    </Link>
                    <Link href="/account/wishlist">
                        <Heart className='size-5 text-black hover:text-primary-700 cursor-pointer transition-all' />
                    </Link>
                </div>
            ) : (
                <Link
                    href="#"
                    onClick={() => openModal(<LoginModal closeAction={closeModal} />)}
                    className="text-black font-semibold text-sm"
                >
                    <span className="hidden lg:block">
                        {"Se connecter / S'inscrire"}
                    </span>
                    <User className="size-5 lg:hidden" />
                </Link>
            )}
        </>
	)
}